/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  DealOutcomeSaveRequest,
  KybOverrideRequest,
  KybOverrideResponse,
  ManualDealCreateRequest,
  ModeratorContractAssignRequest,
  ModeratorContractCreateUpdateRequest,
  ModeratorDeal,
  ModeratorDealAssignRequest,
  ModeratorDealCommentCreateRequest,
  ModeratorDealTimelineUpsertRequest,
  ModeratorsContractsListParams,
  ModeratorsDealsAssignCreate403,
  ModeratorsDealsAssignCreate404,
  ModeratorsDealsListParams,
  ModeratorsDealsMyDealsRetrieveParams,
  PaginatedModeratorDeal,
  PatchedDealOutcomeSaveRequest,
  PatchedModeratorContractCreateUpdateRequest
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * List all contracts created by the current moderator. Optional search by company name; optional filter by contract status. Paginated.
 * @summary List my contracts (moderator)
 */
export const moderatorsContractsList = (
    params?: ModeratorsContractsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/contracts/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsContractsListQueryKey = (params?: ModeratorsContractsListParams,) => {
    return [`/api/v1/moderators/contracts/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsContractsListQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsContractsList>>, TError = unknown>(params?: ModeratorsContractsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsContractsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsContractsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsContractsList>>> = ({ signal }) => moderatorsContractsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsContractsList>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsContractsListQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsContractsList>>>
export type ModeratorsContractsListQueryError = unknown

/**
 * @summary List my contracts (moderator)
 */
export const useModeratorsContractsList = <TData = Awaited<ReturnType<typeof moderatorsContractsList>>, TError = unknown>(
 params?: ModeratorsContractsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsContractsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsContractsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Takes company1Id, company2Id, contractId. Finds the deal between the two companies (matched, or manual — created via deals/createManual) and assigns the contract to it; companies that never matched get 400 (OQ-12), and so does a pair whose only match the supplier declined. Deals that already carry a contract are skipped. Super moderator or the deal's assigned moderator. Contract ID can be numeric or string (reference). A contract already assigned to a deal → 400 `ALREADY_ASSIGNED`. `status` can't be `accepted`: acceptance comes from both owners. The response carries `kybWarnings`; assigning a `completed` contract goes through the KYB contract gate like contract/save.
 * @summary Assign contract to deal between two companies
 */
export const moderatorsContractsAssignCreate = (
    moderatorContractAssignRequest: ModeratorContractAssignRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/contracts/assign/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorContractAssignRequest
    },
      );
    }
  


export const getModeratorsContractsAssignCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsContractsAssignCreate>>, TError,{data: ModeratorContractAssignRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsContractsAssignCreate>>, TError,{data: ModeratorContractAssignRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsContractsAssignCreate>>, {data: ModeratorContractAssignRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsContractsAssignCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsContractsAssignCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsContractsAssignCreate>>>
    export type ModeratorsContractsAssignCreateMutationBody = ModeratorContractAssignRequest
    export type ModeratorsContractsAssignCreateMutationError = void

    /**
 * @summary Assign contract to deal between two companies
 */
export const useModeratorsContractsAssignCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsContractsAssignCreate>>, TError,{data: ModeratorContractAssignRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsContractsAssignCreate>>,
        TError,
        {data: ModeratorContractAssignRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsContractsAssignCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * List all deals with optional search by company name. Shows assigned moderator and timeline. Super moderator only.
 * @summary List all deals (super moderator)
 */
export const moderatorsDealsList = (
    params?: ModeratorsDealsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedModeratorDeal[]>(
      {url: `/api/v1/moderators/deals/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsDealsListQueryKey = (params?: ModeratorsDealsListParams,) => {
    return [`/api/v1/moderators/deals/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsDealsListQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsDealsList>>, TError = unknown>(params?: ModeratorsDealsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsDealsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsDealsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsDealsList>>> = ({ signal }) => moderatorsDealsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsDealsList>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsDealsListQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsDealsList>>>
export type ModeratorsDealsListQueryError = unknown

/**
 * @summary List all deals (super moderator)
 */
export const useModeratorsDealsList = <TData = Awaited<ReturnType<typeof moderatorsDealsList>>, TError = unknown>(
 params?: ModeratorsDealsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsDealsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsDealsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Full deal record. Available to super moderators or the assigned moderator.
 * @summary Get deal detail (moderator)
 */
export const moderatorsDealsRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ModeratorDeal>(
      {url: `/api/v1/moderators/deals/${id}/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsDealsRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/moderators/deals/${id}/`] as const;
    }

    
export const getModeratorsDealsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsDealsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsDealsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsDealsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsDealsRetrieve>>> = ({ signal }) => moderatorsDealsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsDealsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsDealsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsDealsRetrieve>>>
export type ModeratorsDealsRetrieveQueryError = void

/**
 * @summary Get deal detail (moderator)
 */
export const useModeratorsDealsRetrieve = <TData = Awaited<ReturnType<typeof moderatorsDealsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsDealsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsDealsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Assign a moderator to a deal. Super moderator only.
 * @summary Assign moderator to deal (super moderator)
 */
export const moderatorsDealsAssignCreate = (
    id: number,
    moderatorDealAssignRequest: ModeratorDealAssignRequest,
 ) => {
      
      
      return customInstance<ModeratorDeal>(
      {url: `/api/v1/moderators/deals/${id}/assign/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorDealAssignRequest
    },
      );
    }
  


export const getModeratorsDealsAssignCreateMutationOptions = <TError = ModeratorsDealsAssignCreate403 | ModeratorsDealsAssignCreate404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsAssignCreate>>, TError,{id: number;data: ModeratorDealAssignRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsAssignCreate>>, TError,{id: number;data: ModeratorDealAssignRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsDealsAssignCreate>>, {id: number;data: ModeratorDealAssignRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsDealsAssignCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsDealsAssignCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsDealsAssignCreate>>>
    export type ModeratorsDealsAssignCreateMutationBody = ModeratorDealAssignRequest
    export type ModeratorsDealsAssignCreateMutationError = ModeratorsDealsAssignCreate403 | ModeratorsDealsAssignCreate404

    /**
 * @summary Assign moderator to deal (super moderator)
 */
export const useModeratorsDealsAssignCreate = <TError = ModeratorsDealsAssignCreate403 | ModeratorsDealsAssignCreate404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsAssignCreate>>, TError,{id: number;data: ModeratorDealAssignRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsDealsAssignCreate>>,
        TError,
        {id: number;data: ModeratorDealAssignRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsDealsAssignCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Add a comment to a deal. Allowed for the moderator assigned to the deal or a super moderator.
 * @summary Add comment to deal
 */
export const moderatorsDealsCommentsCreate = (
    id: number,
    moderatorDealCommentCreateRequest: ModeratorDealCommentCreateRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/deals/${id}/comments/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorDealCommentCreateRequest
    },
      );
    }
  


export const getModeratorsDealsCommentsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsCommentsCreate>>, TError,{id: number;data: ModeratorDealCommentCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsCommentsCreate>>, TError,{id: number;data: ModeratorDealCommentCreateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsDealsCommentsCreate>>, {id: number;data: ModeratorDealCommentCreateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsDealsCommentsCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsDealsCommentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsDealsCommentsCreate>>>
    export type ModeratorsDealsCommentsCreateMutationBody = ModeratorDealCommentCreateRequest
    export type ModeratorsDealsCommentsCreateMutationError = void

    /**
 * @summary Add comment to deal
 */
export const useModeratorsDealsCommentsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsCommentsCreate>>, TError,{id: number;data: ModeratorDealCommentCreateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsDealsCommentsCreate>>,
        TError,
        {id: number;data: ModeratorDealCommentCreateRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsDealsCommentsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get the contract attached to this deal (if any). Moderator must be super moderator or the assigned moderator.
 * @summary Get contract for a deal
 */
export const moderatorsDealsContractRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/deals/${id}/contract/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsDealsContractRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/moderators/deals/${id}/contract/`] as const;
    }

    
export const getModeratorsDealsContractRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsDealsContractRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsDealsContractRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsDealsContractRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsDealsContractRetrieve>>> = ({ signal }) => moderatorsDealsContractRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsDealsContractRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsDealsContractRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsDealsContractRetrieve>>>
export type ModeratorsDealsContractRetrieveQueryError = void

/**
 * @summary Get contract for a deal
 */
export const useModeratorsDealsContractRetrieve = <TData = Awaited<ReturnType<typeof moderatorsDealsContractRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsDealsContractRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsDealsContractRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * KYB contract gate (`KYB_CONTRACT_GATE`, docs/decisions/kyb.md). With `enforce`, a contract becomes binding (both owners accept, or a moderator completes it) only when both companies are verified. POST records a super moderator's override with a mandatory `reason`, letting the contract through anyway; DELETE clears it. The override is internal: companies never see it.
 * @summary Record or clear a KYB gate override (super moderator)
 */
export const moderatorsDealsContractKybOverrideCreate = (
    id: number,
    kybOverrideRequest: KybOverrideRequest,
 ) => {
      
      
      return customInstance<KybOverrideResponse>(
      {url: `/api/v1/moderators/deals/${id}/contract/kybOverride/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: kybOverrideRequest
    },
      );
    }
  


export const getModeratorsDealsContractKybOverrideCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsContractKybOverrideCreate>>, TError,{id: number;data: KybOverrideRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsContractKybOverrideCreate>>, TError,{id: number;data: KybOverrideRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsDealsContractKybOverrideCreate>>, {id: number;data: KybOverrideRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsDealsContractKybOverrideCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsDealsContractKybOverrideCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsDealsContractKybOverrideCreate>>>
    export type ModeratorsDealsContractKybOverrideCreateMutationBody = KybOverrideRequest
    export type ModeratorsDealsContractKybOverrideCreateMutationError = void

    /**
 * @summary Record or clear a KYB gate override (super moderator)
 */
export const useModeratorsDealsContractKybOverrideCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsContractKybOverrideCreate>>, TError,{id: number;data: KybOverrideRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsDealsContractKybOverrideCreate>>,
        TError,
        {id: number;data: KybOverrideRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsDealsContractKybOverrideCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * KYB contract gate (`KYB_CONTRACT_GATE`, docs/decisions/kyb.md). With `enforce`, a contract becomes binding (both owners accept, or a moderator completes it) only when both companies are verified. POST records a super moderator's override with a mandatory `reason`, letting the contract through anyway; DELETE clears it. The override is internal: companies never see it.
 * @summary Record or clear a KYB gate override (super moderator)
 */
export const moderatorsDealsContractKybOverrideDestroy = (
    id: number,
 ) => {
      
      
      return customInstance<KybOverrideResponse>(
      {url: `/api/v1/moderators/deals/${id}/contract/kybOverride/`, method: 'DELETE'
    },
      );
    }
  


export const getModeratorsDealsContractKybOverrideDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsContractKybOverrideDestroy>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsContractKybOverrideDestroy>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsDealsContractKybOverrideDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  moderatorsDealsContractKybOverrideDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsDealsContractKybOverrideDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsDealsContractKybOverrideDestroy>>>
    
    export type ModeratorsDealsContractKybOverrideDestroyMutationError = void

    /**
 * @summary Record or clear a KYB gate override (super moderator)
 */
export const useModeratorsDealsContractKybOverrideDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsContractKybOverrideDestroy>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsDealsContractKybOverrideDestroy>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getModeratorsDealsContractKybOverrideDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Author the contract attached to this deal. POST creates if none exists; PUT/PATCH updates the existing one. The moderator must be a super moderator or the deal's assigned moderator. `accepted` can't be set here (only both owners' acceptance sets it). Completing a contract goes through the KYB contract gate (`KYB_CONTRACT_GATE`): the response carries `kybWarnings` (companies not verified yet, with their verdict); with `enforce` it is refused unless a super moderator recorded an override (`contract/kybOverride`).
 * @summary Create or update the contract for a deal
 */
export const moderatorsDealsContractSaveCreate = (
    id: number,
    moderatorContractCreateUpdateRequest: ModeratorContractCreateUpdateRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/deals/${id}/contract/save/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorContractCreateUpdateRequest
    },
      );
    }
  


export const getModeratorsDealsContractSaveCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsContractSaveCreate>>, TError,{id: number;data: ModeratorContractCreateUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsContractSaveCreate>>, TError,{id: number;data: ModeratorContractCreateUpdateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsDealsContractSaveCreate>>, {id: number;data: ModeratorContractCreateUpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsDealsContractSaveCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsDealsContractSaveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsDealsContractSaveCreate>>>
    export type ModeratorsDealsContractSaveCreateMutationBody = ModeratorContractCreateUpdateRequest
    export type ModeratorsDealsContractSaveCreateMutationError = void

    /**
 * @summary Create or update the contract for a deal
 */
export const useModeratorsDealsContractSaveCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsContractSaveCreate>>, TError,{id: number;data: ModeratorContractCreateUpdateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsDealsContractSaveCreate>>,
        TError,
        {id: number;data: ModeratorContractCreateUpdateRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsDealsContractSaveCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Author the contract attached to this deal. POST creates if none exists; PUT/PATCH updates the existing one. The moderator must be a super moderator or the deal's assigned moderator. `accepted` can't be set here (only both owners' acceptance sets it). Completing a contract goes through the KYB contract gate (`KYB_CONTRACT_GATE`): the response carries `kybWarnings` (companies not verified yet, with their verdict); with `enforce` it is refused unless a super moderator recorded an override (`contract/kybOverride`).
 * @summary Create or update the contract for a deal
 */
export const moderatorsDealsContractSaveUpdate = (
    id: number,
    moderatorContractCreateUpdateRequest: ModeratorContractCreateUpdateRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/deals/${id}/contract/save/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: moderatorContractCreateUpdateRequest
    },
      );
    }
  


export const getModeratorsDealsContractSaveUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsContractSaveUpdate>>, TError,{id: number;data: ModeratorContractCreateUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsContractSaveUpdate>>, TError,{id: number;data: ModeratorContractCreateUpdateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsDealsContractSaveUpdate>>, {id: number;data: ModeratorContractCreateUpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsDealsContractSaveUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsDealsContractSaveUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsDealsContractSaveUpdate>>>
    export type ModeratorsDealsContractSaveUpdateMutationBody = ModeratorContractCreateUpdateRequest
    export type ModeratorsDealsContractSaveUpdateMutationError = void

    /**
 * @summary Create or update the contract for a deal
 */
export const useModeratorsDealsContractSaveUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsContractSaveUpdate>>, TError,{id: number;data: ModeratorContractCreateUpdateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsDealsContractSaveUpdate>>,
        TError,
        {id: number;data: ModeratorContractCreateUpdateRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsDealsContractSaveUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Author the contract attached to this deal. POST creates if none exists; PUT/PATCH updates the existing one. The moderator must be a super moderator or the deal's assigned moderator. `accepted` can't be set here (only both owners' acceptance sets it). Completing a contract goes through the KYB contract gate (`KYB_CONTRACT_GATE`): the response carries `kybWarnings` (companies not verified yet, with their verdict); with `enforce` it is refused unless a super moderator recorded an override (`contract/kybOverride`).
 * @summary Create or update the contract for a deal
 */
export const moderatorsDealsContractSavePartialUpdate = (
    id: number,
    patchedModeratorContractCreateUpdateRequest: PatchedModeratorContractCreateUpdateRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/deals/${id}/contract/save/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedModeratorContractCreateUpdateRequest
    },
      );
    }
  


export const getModeratorsDealsContractSavePartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsContractSavePartialUpdate>>, TError,{id: number;data: PatchedModeratorContractCreateUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsContractSavePartialUpdate>>, TError,{id: number;data: PatchedModeratorContractCreateUpdateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsDealsContractSavePartialUpdate>>, {id: number;data: PatchedModeratorContractCreateUpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsDealsContractSavePartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsDealsContractSavePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsDealsContractSavePartialUpdate>>>
    export type ModeratorsDealsContractSavePartialUpdateMutationBody = PatchedModeratorContractCreateUpdateRequest
    export type ModeratorsDealsContractSavePartialUpdateMutationError = void

    /**
 * @summary Create or update the contract for a deal
 */
export const useModeratorsDealsContractSavePartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsContractSavePartialUpdate>>, TError,{id: number;data: PatchedModeratorContractCreateUpdateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsDealsContractSavePartialUpdate>>,
        TError,
        {id: number;data: PatchedModeratorContractCreateUpdateRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsDealsContractSavePartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * WP2.3 (c): moderators see every snapshot of the contract — one per save or assign — newest first. Companies only see the current version through the deal-workspace contract endpoint.
 * @summary List version history for a deal's contract
 */
export const moderatorsDealsContractVersionsRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/deals/${id}/contract/versions/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsDealsContractVersionsRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/moderators/deals/${id}/contract/versions/`] as const;
    }

    
export const getModeratorsDealsContractVersionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsDealsContractVersionsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsDealsContractVersionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsDealsContractVersionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsDealsContractVersionsRetrieve>>> = ({ signal }) => moderatorsDealsContractVersionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsDealsContractVersionsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsDealsContractVersionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsDealsContractVersionsRetrieve>>>
export type ModeratorsDealsContractVersionsRetrieveQueryError = void

/**
 * @summary List version history for a deal's contract
 */
export const useModeratorsDealsContractVersionsRetrieve = <TData = Awaited<ReturnType<typeof moderatorsDealsContractVersionsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsDealsContractVersionsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsDealsContractVersionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * WP1.7. Set the outcome (open / won / lost), the lost reason (required for lost; `other` also needs a note), the stage dates (first meeting, proposal, contract signed, lost) and the success-fee attribution (attributed to MatchPoint, deal value + currency). Omitted fields keep their value. Marking a deal won records `wonAt` and attribution (true for matched deals, false for manual ones unless overridden). Both companies are notified when the status or a stage date changes; they never see the reason. Super moderator or the deal's assigned moderator.
 * @summary Record a deal's outcome and stage dates
 */
export const moderatorsDealsOutcomeSaveCreate = (
    id: number,
    dealOutcomeSaveRequest: DealOutcomeSaveRequest,
 ) => {
      
      
      return customInstance<ModeratorDeal>(
      {url: `/api/v1/moderators/deals/${id}/outcome/save/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dealOutcomeSaveRequest
    },
      );
    }
  


export const getModeratorsDealsOutcomeSaveCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsOutcomeSaveCreate>>, TError,{id: number;data: DealOutcomeSaveRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsOutcomeSaveCreate>>, TError,{id: number;data: DealOutcomeSaveRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsDealsOutcomeSaveCreate>>, {id: number;data: DealOutcomeSaveRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsDealsOutcomeSaveCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsDealsOutcomeSaveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsDealsOutcomeSaveCreate>>>
    export type ModeratorsDealsOutcomeSaveCreateMutationBody = DealOutcomeSaveRequest
    export type ModeratorsDealsOutcomeSaveCreateMutationError = void

    /**
 * @summary Record a deal's outcome and stage dates
 */
export const useModeratorsDealsOutcomeSaveCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsOutcomeSaveCreate>>, TError,{id: number;data: DealOutcomeSaveRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsDealsOutcomeSaveCreate>>,
        TError,
        {id: number;data: DealOutcomeSaveRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsDealsOutcomeSaveCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * WP1.7. Set the outcome (open / won / lost), the lost reason (required for lost; `other` also needs a note), the stage dates (first meeting, proposal, contract signed, lost) and the success-fee attribution (attributed to MatchPoint, deal value + currency). Omitted fields keep their value. Marking a deal won records `wonAt` and attribution (true for matched deals, false for manual ones unless overridden). Both companies are notified when the status or a stage date changes; they never see the reason. Super moderator or the deal's assigned moderator.
 * @summary Record a deal's outcome and stage dates
 */
export const moderatorsDealsOutcomeSavePartialUpdate = (
    id: number,
    patchedDealOutcomeSaveRequest: PatchedDealOutcomeSaveRequest,
 ) => {
      
      
      return customInstance<ModeratorDeal>(
      {url: `/api/v1/moderators/deals/${id}/outcome/save/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedDealOutcomeSaveRequest
    },
      );
    }
  


export const getModeratorsDealsOutcomeSavePartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsOutcomeSavePartialUpdate>>, TError,{id: number;data: PatchedDealOutcomeSaveRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsOutcomeSavePartialUpdate>>, TError,{id: number;data: PatchedDealOutcomeSaveRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsDealsOutcomeSavePartialUpdate>>, {id: number;data: PatchedDealOutcomeSaveRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsDealsOutcomeSavePartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsDealsOutcomeSavePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsDealsOutcomeSavePartialUpdate>>>
    export type ModeratorsDealsOutcomeSavePartialUpdateMutationBody = PatchedDealOutcomeSaveRequest
    export type ModeratorsDealsOutcomeSavePartialUpdateMutationError = void

    /**
 * @summary Record a deal's outcome and stage dates
 */
export const useModeratorsDealsOutcomeSavePartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsOutcomeSavePartialUpdate>>, TError,{id: number;data: PatchedDealOutcomeSaveRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsDealsOutcomeSavePartialUpdate>>,
        TError,
        {id: number;data: PatchedDealOutcomeSaveRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsDealsOutcomeSavePartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Set the status (and optional date) of one of the canonical deal timeline milestones — Deal Initiated, Terms Agreed, Contract Signed, Payment Due, Delivery Expected. Idempotent: re-posting overwrites the existing item for that name.
 * @summary Upsert a deal timeline milestone
 */
export const moderatorsDealsTimelineSaveCreate = (
    id: number,
    moderatorDealTimelineUpsertRequest: ModeratorDealTimelineUpsertRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/deals/${id}/timeline/save/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorDealTimelineUpsertRequest
    },
      );
    }
  


export const getModeratorsDealsTimelineSaveCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsTimelineSaveCreate>>, TError,{id: number;data: ModeratorDealTimelineUpsertRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsTimelineSaveCreate>>, TError,{id: number;data: ModeratorDealTimelineUpsertRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsDealsTimelineSaveCreate>>, {id: number;data: ModeratorDealTimelineUpsertRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsDealsTimelineSaveCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsDealsTimelineSaveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsDealsTimelineSaveCreate>>>
    export type ModeratorsDealsTimelineSaveCreateMutationBody = ModeratorDealTimelineUpsertRequest
    export type ModeratorsDealsTimelineSaveCreateMutationError = void

    /**
 * @summary Upsert a deal timeline milestone
 */
export const useModeratorsDealsTimelineSaveCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsTimelineSaveCreate>>, TError,{id: number;data: ModeratorDealTimelineUpsertRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsDealsTimelineSaveCreate>>,
        TError,
        {id: number;data: ModeratorDealTimelineUpsertRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsDealsTimelineSaveCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * OQ-12. Link two approved, active companies that were never matched, with a required reason. The deal is flagged manual (`isManual`) in moderator lists and reporting and is not attributed to MatchPoint by default. Only matched or manual deals can carry a contract.
 * @summary Create a manual deal (super moderator)
 */
export const moderatorsDealsCreateManualCreate = (
    manualDealCreateRequest: ManualDealCreateRequest,
 ) => {
      
      
      return customInstance<ModeratorDeal>(
      {url: `/api/v1/moderators/deals/createManual/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: manualDealCreateRequest
    },
      );
    }
  


export const getModeratorsDealsCreateManualCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsCreateManualCreate>>, TError,{data: ManualDealCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsCreateManualCreate>>, TError,{data: ManualDealCreateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsDealsCreateManualCreate>>, {data: ManualDealCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsDealsCreateManualCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsDealsCreateManualCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsDealsCreateManualCreate>>>
    export type ModeratorsDealsCreateManualCreateMutationBody = ManualDealCreateRequest
    export type ModeratorsDealsCreateManualCreateMutationError = void

    /**
 * @summary Create a manual deal (super moderator)
 */
export const useModeratorsDealsCreateManualCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDealsCreateManualCreate>>, TError,{data: ManualDealCreateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsDealsCreateManualCreate>>,
        TError,
        {data: ManualDealCreateRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsDealsCreateManualCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * List all deals assigned to the current moderator, including timeline.
 * @summary List my assigned deals (moderator)
 */
export const moderatorsDealsMyDealsRetrieve = (
    params?: ModeratorsDealsMyDealsRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedModeratorDeal>(
      {url: `/api/v1/moderators/deals/myDeals/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsDealsMyDealsRetrieveQueryKey = (params?: ModeratorsDealsMyDealsRetrieveParams,) => {
    return [`/api/v1/moderators/deals/myDeals/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsDealsMyDealsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsDealsMyDealsRetrieve>>, TError = unknown>(params?: ModeratorsDealsMyDealsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsDealsMyDealsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsDealsMyDealsRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsDealsMyDealsRetrieve>>> = ({ signal }) => moderatorsDealsMyDealsRetrieve(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsDealsMyDealsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsDealsMyDealsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsDealsMyDealsRetrieve>>>
export type ModeratorsDealsMyDealsRetrieveQueryError = unknown

/**
 * @summary List my assigned deals (moderator)
 */
export const useModeratorsDealsMyDealsRetrieve = <TData = Awaited<ReturnType<typeof moderatorsDealsMyDealsRetrieve>>, TError = unknown>(
 params?: ModeratorsDealsMyDealsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsDealsMyDealsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsDealsMyDealsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



